// eslint-disable-next-line
export const baseUrl=`/api`;
export const authenticationUrl=`/authentication/loggedIn`;
export const loginUrl=`/account/login`;
export const registerUrl=`/account/register`;
export const fetchCoursesUrl=`/course/list`;
export const fetchChaptersUrl=`/chapter/list`;
export const fetchSectionsUrl=`/section/list`;
export const postAppointmentUrl=`/volunteer/apply`;
export const checkAppointmentsUrl= `/volunteer/checkAppointments`;
export const deleteAppointmentUrl=`/volunteer/deleteAppointment`;
export const updateAppointmentUrl=`/volunteer/updateAppointment`;
export const getUserInfoUrl=`/account/getUserInfo`;
export const updateUserInfoUrl=`/account/updateUserInfo`;
export const logoutUrl=`/account/logout`;
export const searchCourseUrl=`/search/course`;